module.exports = __webpack_public_path__ + "static/amir-55edfda144eb6d4e6906009a4cacaa97.webm";